import { useSelector } from "react-redux";
import { RootState } from "common/redux/core/root.reducer";

const useProfile = () => {
  const {
    avatar,
    avatarApiStatus,
    displayName,
    givenName,
    id,
    mail,
    profileApiStatus,
    surname,
    userPrincipalName,
    accessStatus,
    userRole
  } = useSelector((state: RootState) => state.user);
  return {
    avatar,
    avatarApiStatus,
    displayName,
    givenName,
    id,
    mail,
    profileApiStatus,
    surname,
    userPrincipalName,
    accessStatus,
    userRole
  };
};

export default useProfile;
